export const PLYWOOD_PRODUCTION_HISTORY_REQUEST = "PLYWOOD_PRODUCTION_HISTORY_REQUEST";
export const PLYWOOD_PRODUCTION_HISTORY_SUCCESS = "PLYWOOD_PRODUCTION_HISTORY_SUCCESS";
export const PLYWOOD_PRODUCTION_HISTORY_FAILED = "PLYWOOD_PRODUCTION_HISTORY_FAILED";